import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from 'crypto-js'; // 引入 crypto-js
// import './LoginPage.css';
import './AuthPage.css'; // 引入样式文件

const host = process.env.REACT_APP_API_HOST; // API 地址
const cryptoKey = process.env.REACT_APP_CRYPTO_KEY; // 确保与生成令牌时的密钥一致

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        // console.log('Crypto Key:', cryptoKey); // 调试输出密钥
        // 使用 CryptoJS 对密码进行加密
        const encryptedPassword = CryptoJS.AES.encrypt(password, cryptoKey).toString();

// 将加密后的密码发送到后端
        axios.post(`${host}/api/auth/login`, { username, password: encryptedPassword })
            .then(async (response) => {
                localStorage.setItem('token', response.data.token);
                const userInfo = {
                    user_id: response.data.user_id,
                    username: response.data.username,
                    user_name: response.data.user_name,
                    user_role: response.data.user_role,
                    user_email: response.data.user_email,
                };
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                localStorage.setItem('user_id', response.data.user_id);
                localStorage.setItem('username', username);
                localStorage.setItem('user_name', response.data.user_name);
                localStorage.setItem('user_role', response.data.user_role);
                localStorage.setItem('user_email', response.data.user_email);

                // 加载用户设置
                const loadUserSettings = async (userId) => {
                    const token = localStorage.getItem('token');
                    try {
                        const settingsResponse = await axios.get(`${host}/api/data/user_settings/${userId}`, {
                            headers: { Authorization: `Bearer ${token}` },
                        });
                        localStorage.setItem('userSettings', JSON.stringify(settingsResponse.data));
                    } catch (error) {
                        console.error('Failed to load user settings:', error);
                    }
                };

                await loadUserSettings(response.data.user_id); // 等待用户设置加载完成
                navigate('/review'); // 加载完成后导航到 /review 页面
            })
            .catch((error) => {
                setError(error.response?.data?.error || '登录失败，请检查用户名和密码。');
            });
    };

    return (
        <div className="auth-container">
            <h1>铠大师智能体对话管理系统</h1>
            <div className="auth-box">
                <h1>登录</h1>
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label>Username:</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Password:</label>
                        <div className="password-input">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                className={`password-toggle ${showPassword ? 'show' : ''}`}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? '🔓' : '🔒'}
                            </span>
                        </div>
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <div className="form-actions">
                        <button type="submit">Login</button>
                        <p>
                            还没有账号？ <Link to="/register">请注册</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LoginPage;